import { useState, useCallback } from 'react';
import {
  handleSingleSelection,
  handleMultipleSelection,
  handleRangeSelection,
} from '../helpers/photo-selection-handlers';

function useGallerySelection({ items, multiple = false }) {
  const [rangeSelectedItemIds, setRangeSelectedItemIds] = useState([]);
  const [lastClickedItemId, setLastClickedItemId] = useState(null);

  const handleItemClick = useCallback(
    (id, e) => {
      let updatedItems;
      let newRangeSelectedItemIds = [];
      let newLastClickedItemId = id;

      if (multiple) {
        const { shiftKey } = e;

        if (shiftKey && lastClickedItemId) {
          const { updatedItems: rangeUpdatedItems, rangeSelectedItemIds: rangeIds } =
            handleRangeSelection(id, items, lastClickedItemId, rangeSelectedItemIds);

          updatedItems = rangeUpdatedItems;
          newRangeSelectedItemIds = rangeIds;
        } else {
          updatedItems = handleMultipleSelection(id, items);
          newRangeSelectedItemIds = [];
        }
      } else {
        updatedItems = handleSingleSelection(id, items);
        newLastClickedItemId = null;
      }

      setRangeSelectedItemIds(newRangeSelectedItemIds);
      setLastClickedItemId(newLastClickedItemId);

      return updatedItems;
    },
    [multiple, lastClickedItemId, items, rangeSelectedItemIds]
  );

  return { handleItemClick };
}

export default useGallerySelection;
